import React, { useEffect, useState } from 'react';
import { history } from 'umi';
import { Divider  } from 'antd';
import { LeftOutlined  } from '@ant-design/icons';

const BackButton = (props) => { 
  const { stateData, path, title,text } = props;

  // 点击返回触发
  const handleBackButton = () => {   
    history.push({
      pathname: path,
      state: stateData || null,
    });
      
  }
  return (
  <div className="returnBox" onClick={() => { handleBackButton() }}>
    <span  className="returnBtn"><LeftOutlined /><Divider type="vertical" /> {text === '' && '返回'}</span>
    {text !== '' && <span>{text}</span>}
    <span className='title'>{title}</span>
 </div>)
}

export default BackButton;